<template>
  <div class="progress-circle" :class="props.status" data-test="progress-circle">
    <span v-if="status === 'active'" class="number" data-test="progress-circle-number">{{
      number
    }}</span>
    <img
      v-else-if="status === 'completed'"
      src="../../assets/button-icons/tick-icon-white.svg"
      alt="completed"
      class="completed-progress-icon"
      data-test="progress-circle-img"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Status } from "../../typings/shared/status";
import { Variant } from "../../typings/shared/levels-variant";

const props = defineProps<{ number: number; status: Status; variant: Variant }>();

const bgColour = computed(() => {
  if (props.variant === "team") {
    return "#b0bb36";
  }
  if (props.variant === "user") {
    return "#FCAF17";
  }
  return "#000000";
});
</script>

<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables.less";

.progress-circle {
  width: 30px;
  height: 30px;
  border-radius: 100vmax;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.number {
  font-size: 24px;
  font-weight: bold;
}

.active.progress-circle,
.completed.progress-circle {
  background-color: v-bind(bgColour);
}

.active.progress-circle {
  width: 60px;
  height: 60px;

  @media (max-width: @screen-xs-max) {
    width: 40px;
    height: 40px;
  }
}

.uncompleted.progress-circle {
  background-color: transparent;
  border: solid 1px #dddddd;
}

.completed-progress-icon {
  width: 20px;
}
</style>
